// Copyright © 2021 Move Closer
export var ReactionType;
(function (ReactionType) {
    ReactionType["Like"] = "like";
})(ReactionType || (ReactionType = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 * @author Michał Wawer <michal.wawer@movecloser.pl>
 */
export var ContentType;
(function (ContentType) {
    ContentType["Article"] = "article";
    ContentType["Landing"] = "landing";
    ContentType["LiveArticle"] = "live_article";
    ContentType["Page"] = "page";
    ContentType["SmartPage"] = "smart_page";
})(ContentType || (ContentType = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var LayoutContainer;
(function (LayoutContainer) {
    LayoutContainer["Bottom"] = "bottom";
    LayoutContainer["Middle"] = "middle";
    LayoutContainer["Top"] = "top";
})(LayoutContainer || (LayoutContainer = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var LayoutContainerType;
(function (LayoutContainerType) {
    LayoutContainerType["Boxed"] = "boxed";
    LayoutContainerType["FullWidth"] = "full-width";
})(LayoutContainerType || (LayoutContainerType = {}));
/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export var LayoutSlot;
(function (LayoutSlot) {
    LayoutSlot["Bottom"] = "bottom";
    LayoutSlot["Left"] = "left";
    LayoutSlot["Main"] = "main";
    LayoutSlot["Right"] = "right";
    LayoutSlot["Top"] = "top";
    LayoutSlot["Comments"] = "comments";
})(LayoutSlot || (LayoutSlot = {}));
